import React from "react";
import { Quotes, Star } from "@phosphor-icons/react";

const AVATARS = [
  "https://images.unsplash.com/photo-1648474484044-bb82df2f5a1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzY4OTUxNXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzY4OTUxNXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzY4OTUxNXww&ixlib=rb-4.1.0&q=85",
];

const TESTIMONIALS = [
  {
    name: "Maria González",
    role: "Owner, Bright Bloom Florists",
    text: "They rescued two years of customer records from a ransomware attack — same day. Honestly saved our business. We've been on their Complete Care plan ever since.",
  },
  {
    name: "David Patel",
    role: "Retired teacher",
    text: "My laptop was unusable. They picked it up, cleaned out a nasty virus, upgraded to SSD, and now it starts in 12 seconds. Kind, patient, and fair pricing.",
  },
  {
    name: "Jennifer Wu",
    role: "Operations Lead, Cornerstone Legal",
    text: "We switched to their business IT plan and haven't had a single help-desk headache in 8 months. Their response times are genuinely incredible.",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="bg-zinc-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-sm font-semibold uppercase tracking-widest text-blue-600">Client stories</div>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900">
            Loved by home users & businesses alike.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="bg-white rounded-2xl p-8 border border-zinc-200 flex flex-col"
            >
              <Quotes size={28} weight="fill" className="text-blue-600/30" />
              <div className="mt-3 flex items-center gap-1 text-amber-400">
                {[1,2,3,4,5].map(s => <Star key={s} size={14} weight="fill" />)}
              </div>
              <blockquote className="mt-4 text-zinc-700 leading-relaxed flex-1">"{t.text}"</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 pt-6 border-t border-zinc-100">
                <img
                  src={AVATARS[i]}
                  alt={`${t.name} testimonial photo`}
                  loading="lazy"
                  className="h-11 w-11 rounded-full object-cover bg-zinc-200"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    const fallback = e.currentTarget.nextElementSibling;
                    if (fallback) fallback.style.display = 'flex';
                  }}
                />
                <div
                  className="h-11 w-11 rounded-full bg-blue-100 text-blue-700 items-center justify-center font-semibold"
                  style={{ display: 'none' }}
                >
                  {t.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div>
                  <div className="font-semibold text-zinc-900">{t.name}</div>
                  <div className="text-sm text-zinc-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
